<template>
  <div class="cancel_panel ms-controller">
    <el-breadcrumb separator="/" class="bc-nav noborder">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>物流圈</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/abnomalLocation' }">异常定位管理</el-breadcrumb-item>
      <el-breadcrumb-item>异常定位详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="map-warp" :style="heightObj">
      <el-amap
        vid="amap-vue-track"
        ref="trackMap"
        :amap-manager="amapManager"
        :zoom="amap.zoom"
        :center="amap.center"
        :events="mapEvents"
      >
        <el-amap-marker vid="component-marker" :position="[marker.longitude, marker.latitude]">
          <div class="map-icon-common">
            <img src="../../assets/img/common/ico_hcgj_cur@2x.png" width="100%" height="100%" />
          </div>
        </el-amap-marker>
      </el-amap>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VueAMap from 'vue-amap';
import axiosNew from '@/api/axiosNew';
import { WUYI, vali } from '@/api/common';
import api from '@/api/logistics.api';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: 'b9ca46cb108c4f95b883c5de0c070f6b',
  v: '1.4.13'
});
export default {
  name: 'AbnomalLocationDtl',
  data() {
    return {
      id: '',
      amapManager: null, // 地图实体
      marker: {
        longitude: 0,
        latitude: 0
      },
      amap: {
        zoom: 10,
        center: [116.303843, 39.983412]
      },
      mapEvents: {
        init: async map => {
          this.id = this.$route.params.key;
          this.amapManager = map;
          this.init();
          this.infoWindow = new AMap.InfoWindow({
            anchor: 'middle-left',
            isCustom: true,
            autoMove: true,
            offset: new AMap.Pixel(20, -15)
          });
        }
      },

      heightObj: {
        height: window.innerHeight - 60 - 58 - 20 + 'px'
      }
    };
  },
  created() {},
  methods: {
    async init() {
      let res = await axiosNew.post(api.monitorCompanyAddressById, { id: this.id });
      // 兼容处理
      if (!res.data) {
        this.$message.error('暂无位置信息');
        return;
      }
      this.amap.center = [res.data.longitude, res.data.latitude];
      this.marker.longitude = res.data.longitude;
      this.marker.latitude = res.data.latitude;
      let content = `<div class="map-window-dtl-warp">${res.data.addressName}</div>`;
      this.infoWindow.setContent(content);
      this.infoWindow.open(this.amapManager, this.amap.center);
    }
  }
};
</script>
<style scoped>
.map-icon-common {
  width: 28px;
  height: 36px;
}
</style>
<style>
.map-window-dtl-warp {
  background: #fff;
  padding: 5px;
  width: 200px;
  position: relative;
  border: 1px solid #e4e7ed;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
  color: #5a5e66;
  font-size: 14px;
}
.map-window-dtl-warp:before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  top: 50%;
  margin-top: -5px;
  left: -6px;
  border-top: 6px solid transparent;
  border-right: 6px solid #fff;
  border-bottom: 6px solid transparent;
}
</style>
